<template>
  <div class="news-slider" v-if="news.length">
    <!-- Slider con transiciones -->
    <transition name="fade">
      <div
        v-if="news[currentIndex]"
        :key="currentIndex"
        class="slide"
      >
        <img v-if="news[currentIndex].image" :src="news[currentIndex].image" alt="Noticia">
        <div class="content">
          <h2>{{ news[currentIndex].title }}</h2>
          <p v-html="news[currentIndex].description"></p>
          <!-- <a :href="news[currentIndex].link" target="_blank">Leer más</a> -->
        </div>
      </div>
    </transition>
    <!-- Botones de navegación -->
    <button class="prev" @click="prevSlide">❮</button>
    <button class="next" @click="nextSlide">❯</button>
  </div>
  <div class="text-center mt-48" v-else>
    <p>Cargando noticias...</p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "NewsSlider",
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      news: [], // Array donde almacenaremos las noticias
      currentIndex: 0,
      autoplayInterval: null,
    };
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.news.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.news.length) % this.news.length;
    },
    startAutoplay() {
      if (this.autoplay) {
        this.autoplayInterval = setInterval(this.nextSlide, this.interval);
      }
    },
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    },
    fetchNews() {
      axios
        .get(this.$root.news_url())
        .then((response) => {
          // Suponiendo que la respuesta es un array de noticias
          this.news = response.data;
          this.startAutoplay(); // Iniciar autoplay una vez que las noticias estén cargadas
        })
        .catch((error) => {
          console.error("Error al cargar las noticias:", error);
        });
    },
  },
  mounted() {
    this.fetchNews(); // Obtener las noticias al montar el componente
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
};
</script>

<style scoped>
.news-slider {
  position: relative;
  width: 100%;
  max-width: 600px;
  height: 400px;
  margin: auto;
  overflow: hidden;
  margin-top: 10px;
}

.slide {
  position: absolute;
  width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  left: 100px;
}

img {
  max-width: 100%;
  height: auto;
  margin-bottom: 1rem;
  max-height: 200px;
}

.content h2 {
  font-size: 1.2rem;
  margin: 0.5rem 0;
}

.content p {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: #666;
}

button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5em;
  width: 50px;
}

button.prev {
  left: 10px;
}

button.next {
  right: 10px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
